<template>
    <div id="main">
        <ClienteList 
            v-show="!rotaAninhada" 
            :reloadData="reloadData" 
            :abrev="abrev"
        />
        <router-view />
    </div>
</template>

<script>
import ClienteList from '@/components/vendas/cliente/ClienteList.vue';

export default {
    name: 'ClienteListRoute',

    beforeRouteUpdate(to, from, next) {
        this.rotaAninhada = to.name != `${this.abrev}-cliente-list`;
        if (from.name != `${this.abrev}-cliente-list` && to.name == `${this.abrev}-cliente-list`) {
            this.reloadData = true;
            setTimeout(() => (this.reloadData = false), 300);
        }
        next();
    },
    components: {
        ClienteList,
    },
    data() {
        return {
            rotaAninhada: false,
            reloadData: false,
            abrev: this.$route.meta.contexto.slice(0,3),
        };
    },
    created() {
        if (this.$route.meta.contexto == "agro") {
            this.abrev = this.$route.meta.contexto.slice(0,4);
        }

        this.rotaAninhada =
            this.$route.name.includes(`${this.abrev}-cliente`) &&
            this.$route.name != `${this.abrev}-cliente-list`;
    },
};
</script>
<style lang="scss" scoped>
    #main {
        padding: 0 20px;
        height: 100%;
    }
</style>